import { clsx } from 'clsx';
import React, { forwardRef, useRef, useImperativeHandle, useEffect, useCallback } from 'react';
import { CopilotMessage } from '../CopilotMessage/CopilotMessage.es.js';

const messageList = "_messageList_ptznf_1";
const hideScrollbar = "_hideScrollbar_ptznf_8";
const styles = {
	messageList: messageList,
	hideScrollbar: hideScrollbar
};

const CopilotMessageList = forwardRef((props, ref) => {
  const { messages, className, style, renderMessage, autoScroll = true, renderPart, isDebug, renderPartContent, getToolCallDisplay, actions } = props;
  const innerRef = useRef(null);
  useImperativeHandle(ref, () => innerRef.current, []);
  const isUserAtBottomRef = useRef(true);
  useEffect(() => {
    if (!autoScroll)
      return;
    const container = innerRef.current;
    if (!container)
      return;
    const handleScroll = () => {
      const threshold = 8;
      const isAtBottom = container.scrollHeight - container.scrollTop - container.clientHeight <= threshold;
      isUserAtBottomRef.current = isAtBottom;
      if (isAtBottom) {
        container.classList.add(styles.hideScrollbar);
      } else {
        container.classList.remove(styles.hideScrollbar);
      }
    };
    container.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [autoScroll]);
  useEffect(() => {
    if (!autoScroll)
      return;
    const container = innerRef.current;
    if (!container)
      return;
    container.scrollTop = container.scrollHeight;
    isUserAtBottomRef.current = true;
    container.classList.add(styles.hideScrollbar);
  }, [autoScroll]);
  useEffect(() => {
    if (!autoScroll)
      return;
    const container = innerRef.current;
    if (!container)
      return;
    if (isUserAtBottomRef.current) {
      container.scrollTop = container.scrollHeight;
    }
  }, [messages, autoScroll]);
  const renderSingleMessage = useCallback((message, index) => {
    const customRendered = renderMessage ? renderMessage(message, index) : void 0;
    return React.createElement(React.Fragment, { key: message.id }, customRendered !== void 0 ? customRendered : React.createElement(CopilotMessage, { message, renderPart, isDebug, renderPartContent, getToolCallDisplay, actions }));
  }, [renderMessage]);
  return React.createElement("div", { ref: innerRef, className: clsx(styles.messageList, className, {
    [styles.hideScrollbar]: isUserAtBottomRef.current
  }), style, "data-zds": true }, messages.map(renderSingleMessage));
});
CopilotMessageList.displayName = "CopilotMessageList";

export { CopilotMessageList, CopilotMessageList as default };
//# sourceMappingURL=CopilotMessageList.es.js.map
